import React from "react";
// import styled from "styled-components";
import "./Hero.css";

export default function Hero({ children, hero }) {
  return <header className={hero}>{children}</header>;
}

Hero.defaultProps = {
  hero: "defaultHero",
};
